<template>
  <div class="main-wrapper">
    <Header></Header>
    <Sidebar></Sidebar>
    <div class="page-wrapper">
      <router-view></router-view>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Header from "./Header.vue";
import Sidebar from "./Sidebar.vue";
import Footer from "./Footer.vue";
export default {
  components: {
    Header,
    Sidebar,
    Footer,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.page-wrapper {
  margin-left: 245px;
}

@media only screen and (min-width: 991px) {
  .mini-sidebar .page-wrapper {
    margin-left: 60px;
  }
}
@media only screen and (max-width: 991.98px) {
  .page-wrapper {
    margin-left: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Layout/Layout.vue